var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Select,{attrs:{"value":_vm.value,"options":_vm.options},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }